import ua from 'ua'

const isProduct = ua.isProduct()
const isDev = ua.isDev()
const ClientTypes = {
  ios: 10,
  android: 11,
  h5: 12,
  weapp: 13,
  alipay: 14,
}
let clientType;

switch (true) {
  case ua.isPiaoniuMiniProgram():
    clientType = 13;
    break;
  case ua.isPiaoniuAliMiniProgram():
    clientType = 14;
    break;
  case ua.isPiaoniu() && ua.isIOS():
    clientType = 10;
    break;
    case ua.isPiaoniu() && ua.isAndroid():
    clientType = 11;
    break;
  default:
    clientType = 12;
}

// TODO: 将逻辑统一迁移到config.production.js / config.beta.js维护
var config = {
  clientType,
  apiHost: isProduct ? 'api.piaoniu.com' : 'mbeta.piaoniu.com/api',
  cdnHost: isDev ? ('//' + location.host) : (isProduct ? '//static.piaoniu.com/m' : '//mbeta.piaoniu.com/m'),
  wechatAppId: isProduct ? 'wxac94f6f29c637242' : 'wxac94f6f29c637242',
  downloadURL: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ipiaoniu.android&g_f=991653',
  homePage: ua.isMobile() ? '/' : ('//' + (isProduct ? 'www.piaoniu.com' : 'wwwbeta.piaoniu.com')),
  isProduct: isProduct
}

export default config



// WEBPACK FOOTER //
// ./src/mods/consts.js